const ReviewsStats = (() => {
  "use strict";

  const CONFIG = Object.freeze({
    rateLimitMs: 3e4,
    cacheKey: "rv_stats"
  });

  let lastFetchAt = 0;

  function readCache() {
    try {
      const raw = localStorage.getItem(CONFIG.cacheKey);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return (typeof parsed === "object" &&
              Number.isFinite(parsed.total) &&
              typeof parsed.average === "string" &&
              /^\d+\.\d$/.test(parsed.average))
        ? { total: parsed.total, average: parsed.average }
        : (localStorage.removeItem(CONFIG.cacheKey), null);
    } catch (err) {
      localStorage.removeItem(CONFIG.cacheKey);
      return null;
    }
  }

  function writeCache(stats) {
    try {
      localStorage.setItem(CONFIG.cacheKey, JSON.stringify(stats));
    } catch (err) { /* storage unavailable — ignore */ }
  }

  async function fetchStats({ bustCache = false } = {}) {
    if (!bustCache) {
      const cached = readCache();
      if (cached) return { ...cached, fromCache: true };
    }

    const now = Date.now();
    if (!bustCache && now - lastFetchAt < CONFIG.rateLimitMs) {
      const waitS = Math.ceil((CONFIG.rateLimitMs - (now - lastFetchAt)) / 1000);
      throw new Error(`Rate limit: wait ${waitS}s before retrying.`);
    }
    lastFetchAt = now;

    // Goes through the real SignageReviews helper (hits
    // /reviews?per_page=1&page=1 on the signage-dashboard API and has
    // its own 30-min cache) instead of calling a guessed stats route
    // or Shopify's Storefront API directly with an exposed token.
    const raw = await SignageReviews.fetchStats();
    if (!raw) throw new Error("Stats request failed.");

    const total = Number(raw.totalReviews) || 0;
    const average = total > 0 ? Number(raw.avgRating).toFixed(1) : "0.0";
    const stats = { total, average };

    writeCache(stats);
    return { ...stats, fromCache: false };
  }

  return {
    init() { fetchStats().catch(() => {}); },
    fetchStats
  };
})();

document.addEventListener("DOMContentLoaded", () => ReviewsStats.init());